
import {
  computed,
  defineComponent,
  PropType,
  onMounted,
  toRefs,
  reactive,
  ref,
  watch
} from 'vue'

// import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import ListHeader from '@/components/ListHeader.vue'
import ObjectTree from '@/components/ObjectTree.vue'
import { Entry, EntryConfig, RequestHandler } from '@Protium/vue-ozone-utils'
import { Fulfillment, OrderStatusInfo, ShipmentLabel } from '@/models/interfaces/order'
import { useQuasar } from 'quasar'
import { isUUID } from '@/utils'
import { generateTrackingUrl } from '@/utils/shipment'
import { Address } from '@/models/generics'
import { OperationalData } from '@/pages/Dashboard/components/interfaces/index'

export default defineComponent({
  name: 'OperationalData',
  components: { ListHeader, ObjectTree },
  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object as PropType<OperationalData>,
      required: true
    },
    request: {
      type: Object as PropType<RequestHandler<Entry>>
    },
    edit: {
      type: Boolean,
      default: false
    },
    showIssues: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const $quasar = useQuasar()
    const $store = useStore()
    const $request = props.request || $store.getters['Services/Directr']
    const isEditing = ref(false)
    const editing = computed(() => isEditing.value || props.edit)
    const OperationalDataInput = ref()

    // COMBAK we could possibly automate this process of creating computed props with getter/setter function for nested v-model modelValues by generating a computed by key...
    const operationalState = reactive({
      notes: computed({
        get: () => {
          return props.modelValue?.notes || ''
        },
        set: (value) => {
          // console.log('notes setter', value)
          emit('update:modelValue', { ...props.modelValue, notes: value })
        }
      }),
      meta: computed({
        get: () => {
          return props.modelValue?.meta || ''
        },
        set: (value) => {
          emit('update:modelValue', { ...props.modelValue, meta: value })
        }
      })
    })

    const diff = ref(false)

    watch(() => props.edit, value => {
      if (value) OperationalDataInput.value.focus()
    })

    onMounted(() => {
      if (editing.value) OperationalDataInput.value.focus()
    })

    function save (field?: string) {
      if (!isUUID(props.id)) {
        console.warn(`Operational Data | Could not save data, the passed "id" prop was not a valid UUID (was ${props.id})`)
        return
      }
      // console.log('saving...', { operational_notes: operationalState.notes, meta: operationalState.meta })
      if ($request.order?.patchOperationalNote) $request.order?.patchOperationalNote(props.id, { operational_notes: operationalState.notes })
      const patchData = $request.order?.patchOperationalNote ? { meta: operationalState.meta } : { meta: operationalState.meta, operational_notes: operationalState.notes }

      $request.patch(props.id, patchData).then(({ items: [updated] }) => {
        emit('update:modelValue', { ...props.modelValue, notes: operationalState.notes, meta: operationalState.meta })

        isEditing.value = false
        diff.value = false
        $quasar.notify({
          message: 'Operational data updated',
          type: 'positive',
          classes: 'custom-notify success',
        })

      }).catch(e => {
        console.error('Operational Data | error during status update request:', e)
      })
    }

    return {
      operationalState,
      OperationalDataInput,
      save,
      isEditing,
      editing,
      diff
    }
  }
})
